import { render } from "./AnalyzesComponent.vue?vue&type=template&id=4fbf1a06"
import script from "./AnalyzesComponent.vue?vue&type=script&lang=js"
export * from "./AnalyzesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__